const checkResponseJSON = response => {
  if (response.ok) {
    return response.json()
  }

  throw new Error(response.statusText)
}

export default checkResponseJSON



// WEBPACK FOOTER //
// ./utils/Fetch.js